"use client";
import { Flex, Text } from "@radix-ui/themes";

export const ErrorMsg = ({ children }: { children: React.ReactNode }) => (
  <Text size="1" color="crimson">
    {children}
  </Text>
);

export function FormField({
  label,
  error,
  children,
  required,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
  required?: boolean;
}) {
  return (
    <Flex direction="column">
      <Text as="label" size="2" mb="1" weight="bold">
        {label}
        {required && (
          <Text
            as="span"
            color="crimson"
            style={{ fontSize: "0.75rem" }}
            ml="1"
          >
            * Required
          </Text>
        )}
      </Text>
      {children}
      {error && <ErrorMsg>{error}</ErrorMsg>}
    </Flex>
  );
}
